import { ApiError } from "@/services/api/client";

/** Return a human message for an unknown error, preserving the API detail when present. */
export function errorMessage(error: unknown): string {
  if (error instanceof ApiError) {
    return error.message;
  }
  if (error instanceof Error) {
    return error.message;
  }
  return "Unexpected error";
}

/** Re-export so consumers can type-check against the API error shape. */
export type { ApiError };

